<div class="side-nav-container w-56 h-full roboto-medium-font body-s">
  <div
    routerLink="/home"
    routerLinkActive="selected"
    class="nav-btn flex flex-col items-center justify-center w-full"
  >
    <kds-icon-home size="m"></kds-icon-home>
    <span class="text-center">Home</span>
  </div>
  <!-- routerLink="['/item-review','/branch-review']" -->
  <!-- <div
    routerLinkActive="selected"
    (click)="reviewMenu.toggle($event)"
    class="nav-btn flex flex-col items-center justify-center w-full"
  >
    <kds-icon-table-view size="m"></kds-icon-table-view>
    <span class="text-center">Manual Review</span>
  </div> -->
  <div
    routerLink="../branch-review"
    routerLinkActive="selected"
    class="nav-btn flex flex-col items-center justify-center w-full my-12"
  >
    <kds-icon-table-view size="m"></kds-icon-table-view>
    <span class="text-center">Branch Review</span>
  </div>
  <div
    routerLink="../item-review"
    routerLinkActive="selected"
    class="nav-btn flex flex-col items-center justify-center w-full my-12"
  >
    <kds-icon-table-view size="m"></kds-icon-table-view>
    <span class="text-center">Item Review</span>
  </div>
  <div
    routerLink="../search-gtin"
    routerLinkActive="selected"
    class="nav-btn flex flex-col items-center justify-center w-full my-12"
  >
    <kds-icon-search size="m"></kds-icon-search>
    <span class="text-center">Item Search</span>
  </div>
  <div
    routerLink="../tender-type"
    routerLinkActive="selected"
    class="nav-btn flex flex-col items-center justify-center w-full my-12"
  >
    <kds-icon-list-view size="m"></kds-icon-list-view>
    <span class="text-center">Tender Type</span>
  </div>
  <!-- <div class="nav-btn flex flex-col items-center justify-center w-full">
    <kds-icon-file size="m"></kds-icon-file>
    <span class="text-center">TCC</span>
  </div>
  <div class="nav-btn flex flex-col items-center justify-center w-full">
    <kds-icon-layers size="m"></kds-icon-layers>
    <span class="text-center">Edit History</span>
  </div> -->
</div>
<!-- <p-menu
  #reviewMenu
  [model]="reviewItems"
  [popup]="true"
  class="review-menu"
></p-menu> -->
